module.exports = __webpack_public_path__ + "img/chef-vector.2606e98f.png";